import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  duplicateLabel: {
    id: "questionbank.actions.duplicateLabel",
    defaultMessage: "Duplicate"
  },
  submitLabel: {
    id: "questionbank.actions.submitLabel",
    defaultMessage: "Submit"
  },
  publishLabel: {
    id: "questionbank.actions.publishLabel",
    defaultMessage: "Publish"
  },
  editLabel: {
    id: "questionbank.actions.editLabel",
    defaultMessage: "Edit"
  },
  youSureDialogTitle: {
    id: "questionbank.actions.youSureDialogTitle",
    defaultMessage: "Are you sure?"
  },
  deleteQuestionDialogMessage: {
    id: "questionbank.actions.deleteQuestionDialogMessage",
    defaultMessage: "Are you sure you want to delete this question? You will not be able to recover it!"
  },
  yesDeleteButton: {
    id: "questionbank.actions.yesDeleteButton",
    defaultMessage: "Yes delete!"
  },
  cancelQuestionDialogMessage: {
    id: "questionbank.actions.cancelQuestionDialogMessage",
    defaultMessage: "Are you sure you want to cancel this question? It will be no longer published!"
  },
  submitQuestionDialogMessage: {
    id: "questionbank.actions.submitQuestionDialogMessage",
    defaultMessage: "Are you sure you want to submit this question? It will be put into review"
  },
  yesSubmitButton: {
    id: "questionbank.actions.yesSubmitButton",
    defaultMessage: "Yes Submit!"
  },
  yesPublishButton: {
    id: "questionbank.actions.yesPublishButton",
    defaultMessage: "Yes Publish!"
  },
  publishQuestionDialogMessage: {
    id: "questionbank.actions.publishQuestionDialogMessage",
    defaultMessage: "Are you sure you want to publish this question? It will be publicly available"
  },
  editQuestionTypography: {
    id: "questionbank.actions.editQuestionTypography",
    defaultMessage: "Edit question"
  },
  viewQuestionTitle: {
    id: "questionbank.actions.viewQuestionTitle",
    defaultMessage: "View question"
  },
  createTagLabel: {
    id: "questionbank.actions.createTagLabel",
    defaultMessage: "Create Tag"
  },
  nameOfTagLabel: {
    id: "questionbank.actions.nameOfTag",
    defaultMessage: "Name of the tag"
  }
});